// This function allow to reference async chunks and chunks that the entrypoint depends on
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 792) return "static/chunks/main-bd8dc15af7264bae.js";
	if (chunkId === 636) return "static/chunks/pages/_app-e003cea9cda24936.js";
	if (chunkId === 593) return "static/chunks/framework-45bd693ecd8cb99d.js";
	if (chunkId === 240) return "static/chunks/240-61f4382494f1e558.js";
	if (chunkId === 196) return "static/chunks/196-d9cf8f8d05d06161.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"19":"5b855c9f6c042062","128":"cca2bf66ee087169","258":"9e73e412b2223e8a","288":"4256b7d2ad10d708","648":"2e78c666d1df85ec","719":"c000ff9b2a8541f6","738":"40ff21cc98cc8555","770":"ed7f25d4ea80c67a","871":"bc49b2d01173ac59","988":"6e717061aee4fd37"}[chunkId] + ".js";
};